import { render, staticRenderFns } from "./AppToolbar.vue?vue&type=template&id=2bd95eda"
import script from "./AppToolbar.vue?vue&type=script&lang=js"
export * from "./AppToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports